import Experience from "../Experience/Experience";
import EventEmitter from "../Experience/Utils/EventEmitter";

export default class Router extends EventEmitter {
    constructor() {
        super();
        this.experience = new Experience();
        this.camera = this.experience.camera;
        this.canvas = this.experience.canvas;
        this.html = null;
        this.path = null;
        this.prevRoute = window.location.pathname;
        this.isRouting = false;

        this.routes = {
            404: "./pages/404.html",
            "/": "./pages/home.html",
            "/about": "./pages/about.html",
            "/contact": "./pages/contact.html",
        };



        /**
         * Créer des routes en fonction d'un tableau de données (de leur nom ou de leur id)
         */
        // fetch('./productData.json')
        //     .then(response => response.json())
        //     .then(data => {
        //         for (let i = 0; i < data.data.length; i++) {
        //             const product = data.data[i];
        //             this.routes[`/${product.textureName}`] = `./pages/page.html`;
        //         }
        //         this.handleLocation(); // Appel de handleLocation une fois toutes les routes ajoutées
        //     })
        //     .catch(error => {
        //         console.error('Une erreur s\'est produite lors de la récupération des données du produit :', error);
        //     });





        window.onpopstate = this.handleLocation();
    }

    route = (event) => {
        event = event || window.event;
        this.prevRoute = window.location.pathname;
        event.preventDefault();
        window.history.pushState({}, "", event.target.href);
        this.handleLocation();

    };

    handleLocation = async () => {
        if (this.isRouting) return;
        this.isRouting = true;
        this.path = window.location.pathname;
        const route = this.routes[this.path] || this.routes[404];
        this.html = await fetch(route).then((data) => data.text());
        this.trigger('routing');
        this.isRouting = false;
    };
}
